import { render, staticRenderFns } from "./edit-item-value.vue?vue&type=template&id=47aaa332&"
import script from "./edit-item-value.vue?vue&type=script&lang=js&"
export * from "./edit-item-value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports